export const adminManager = {
    "admin_manager_title": "Super Admin Management",
    "admin_manager_tab_Group": "User Groups",
    "admin_manager_tab_Users": "Teachers",
    "admin_manager_tab_Students": "Students",
    "admin_manager_tab_Classes": "Classes",
    "admin_manager_tab_TeachingLocation": "Teaching Location",
    "admin_manager_tab_Subject": "Subjects",
    "admin_manager_tab_WorkingTimeSheet": "TimeSheet",
    "admin_manager_tab_RegisterCoder": "Invitation Codes"
};

export const registerCoder = {
    "register_code_invitation_code": "Invitation Code",
    "register_code_status": "Status",
    "register_code_disabled": "Disabled",
    "register_code_enabled": "Enabled",
    "register_code_expiry_time": "Expiry Time",
    "register_code_days_left": "{{days}} days",
    "register_code_days_right": "180 days",
    "register_code_remaining_invites": "Remaining Invites",
    "register_code_people": "{{count}} people",
    "register_code_max_people": "15 people",
    "register_code_copy": "Copy",
    "register_code_enable": "Enable",
    "register_code_disable": "Disable",
    "register_code_reset": "Reset",
    "register_code_delete": "Delete",
    "register_code_confirm_delete": "Are you sure to delete?",
    "register_code_create": "Create",
    "register_code_copy_success": "Copied successfully",
    "register_code_action": "Action",
};

export const timesheetList = {
    "timesheet_list_title_name": "Name",
    "timesheet_list_title_title": "Title",
    "timesheet_list_title_target_audience": "Target Audience",
    "timesheet_list_tag_none": "None",
    "timesheet_list_title_submission_period": "Submission Period",
    "timesheet_list_weeks": "{{weeks}} week(s)",
    "timesheet_list_title_grace_days": "Grace Days After Deadline",
    "timesheet_list_grace_days": "+{{days}} day(s)",
    "timesheet_list_title_version": "Version",
    "timesheet_list_version_tag": "v{{ver}}",
    "timesheet_list_action": "Actions",
    "timesheet_list_action_view": "View",
    "timesheet_list_action_update": "Update",
    "timesheet_list_action_delete": "Delete",
    "timesheet_list_confirm_delete_title": "Are you sure you want to delete this timesheet?",
    "timesheet_list_confirm_delete_content": "This action cannot be undone.",
    "timesheet_list_confirm_ok": "Yes",
    "timesheet_list_confirm_cancel": "No",
    "timesheet_list_create_button": "Create",
    "timesheet_list_modal_title_create": "Create TimeSheet",
    "timesheet_list_modal_title_update": "Update TimeSheet: {{name}}",
    "timesheet_list_success_delete": "Timesheet successfully deleted!",
    "timesheet_list_error_delete": "Error deleting timesheet"
};

export const groupManager = {
    "group_manager_create_button": "Create User Group",
    "group_manager_modal_create_title": "Create User Group",
    "group_manager_form_label_name": "User Group Name",
    "group_manager_form_placeholder": "Enter user group name",
    "group_manager_modal_cancel": "Cancel",
    "group_manager_modal_create_confirm": "Create",
    "group_manager_modal_delete_title": "Delete User Group",
    "group_manager_confirm_delete_message": "Are you sure you want to delete user group {{id}}?",
    "group_manager_modal_delete_confirm": "Delete",
    "group_manager_table_header_id": "ID",
    "group_manager_table_header_name": "Name",
    "group_manager_table_header_user_count": "Number of Users",
    "group_manager_table_header_actions": "Actions",
    "group_manager_action_add_users": "Add/Remove Users",
    "group_manager_action_delete_group": "Delete Group"
};

export const managerLocation = {
    "teaching_location_add_button": "Add teaching location",
    "teaching_location_modal_title": "Add teaching location",
    "teaching_location_column_name": "Name",
    "teaching_location_column_remark": "Remark",
    "teaching_location_column_action": "Action",
    "teaching_location_delete_confirm": "Are you sure you want to delete?",
    "teaching_location_delete_button": "Delete",
    "teaching_location_form_label_name": "Name",
    "teaching_location_form_label_remark": "Remark",
    "teaching_location_form_required_name": "Please enter the name",
    "teaching_location_msg_add_success": "Add success",
    "teaching_location_msg_add_failed": "Add failed",
    "teaching_location_msg_delete_success": "Delete success",
    "teaching_location_msg_delete_failed": "Delete failed",
    "teaching_location_msg_fetch_failed": "Failed to load teaching locations"
};

export const TeachingSubjectManager = {
    "teaching_course_add_button": "Add Teaching Subject",
    "teaching_course_modal_title": "Add Teaching Subject",
    "teaching_course_column_name": "Name",
    "teaching_course_column_action": "Action",
    "teaching_course_delete_confirm": "Are you sure you want to delete?",
    "teaching_course_delete_button": "Delete",
    "teaching_course_form_label_name": "Name",
    "teaching_course_form_required_name": "Please enter the subject name",
    "teaching_course_msg_fetch_failed": "Failed to load teaching subjects",
    "teaching_course_msg_add_success": "Subject added successfully",
    "teaching_course_msg_add_failed": "Failed to add subject",
    "teaching_course_msg_delete_success": "Subject deleted successfully",
    "teaching_course_msg_delete_failed": "Failed to delete subject"
};

export const UsersManager = {
    "user_manager_tab_base_users": "Tutors",
    "user_manager_tab_pending_users": "Pending Termination Tutors",
    "user_manager_tab_terminated_users": "Terminated Tutors",
    "terminated_users_table_column_index": "No.",
    "terminated_users_table_column_name": "Name",
    "terminated_users_table_column_terminated_time": "Termination Date",
    "pending_users_column_index": "No.",
    "pending_users_column_name": "Name",
    "pending_users_column_last_login": "Last Login",
    "pending_users_column_expected_terminate_time": "Expected Termination Date",
    "pending_users_column_action": "Actions",
    "pending_users_action_resume": "Resume",
    "pending_users_action_terminate": "Terminate",
    "pending_users_confirm_resume_title": "Resume {{name}}?",
    "pending_users_confirm_resume_content": "{{name}} will resume their tutoring duties.",
    "pending_users_confirm_terminate_title": "Permanently Terminate {{name}}?",
    "pending_users_confirm_terminate_content": "This action cannot be undone. {{name}} will be permanently removed from the system.",
    "pending_users_msg_resume_success": "{{name}} resumed successfully.",
    "pending_users_msg_resume_error": "Failed to resume {{name}}.",
    "pending_users_msg_terminate_success": "{{name}} terminated successfully.",
    "pending_users_msg_terminate_error": "Failed to terminate {{name}}.",
    "base_users_column_id": "ID",
    "base_users_column_name": "Name",
    "base_users_column_last_login": "Last Login",
    "base_users_column_auth": "Roles",
    "base_users_column_mark_name": "Alias",
    "base_users_column_actions": "Actions",
    "base_users_action_rename": "Rename",
    "base_users_action_terminate": "Mark for Termination",
    "base_users_modal_rename_title": "Set Alias",
    "base_users_modal_rename_placeholder": "Enter alias",
    "base_users_select_roles_placeholder": "Select roles",
    "base_users_confirm_terminate_title": "Mark {{name}} for Termination?",
    "base_users_confirm_terminate_content_p1": "This user will no longer appear in shared file lists or query results.",
    "base_users_confirm_terminate_content_p2": "You can still find this user in the `Pending Termination` list.",
    "base_users_confirm_terminate_content_p3": "The user will be permanently deleted after 7 days.",
    "base_users_confirm_terminate_content": "This user will be hidden from shared files and queries. They will appear in the 'Pending Termination' list and be permanently deleted after 7 days.",
    "base_users_msg_fetch_error": "Failed to load users.",
    "base_users_msg_update_auth_success": "Roles updated successfully.",
    "base_users_msg_update_auth_error": "Failed to update roles.",
    "base_users_msg_mark_terminate_success": "{{name}} marked for termination.",
    "base_users_msg_mark_terminate_error": "Failed to mark {{name}} for termination.",
    "base_users_msg_update_mark_name_success": "Alias updated successfully.",
    "base_users_msg_update_mark_name_error": "Failed to update alias.",
};

export const studentManager = {
    "student_manager_msg_fetch_error": "Failed to fetch student list",
    "student_manager_msg_create_success": "Student created successfully",
    "student_manager_msg_create_error": "Failed to create student",
    "student_manager_msg_name_required": "Please enter name",
    "student_manager_msg_course_location_required": "Please select location",
    "student_manager_msg_update_success": "Student updated successfully",
    "student_manager_msg_update_error": "Failed to update student",
    "student_manager_msg_delete_success": "Student deleted successfully",
    "student_manager_msg_delete_error": "Failed to delete student",
    "student_manager_msg_disable_success": "Operation successful",
    "student_manager_msg_disable_error": "Operation failed",
    "student_manager_msg_reset_password_success": "Password reset successfully",
    "student_manager_msg_reset_password_error": "Failed to reset password",
    "student_manager_search_placeholder": "Search by name or email",
    "student_manager_filter_location_placeholder": "Select location",
    "student_manager_search_button": "Search",
    "student_manager_create_button": "Create Student",
    "student_manager_column_id": "ID",
    "student_manager_column_name": "Name",
    "student_manager_column_email": "Email",
    "student_manager_column_first_name": "First Name",
    "student_manager_column_last_name": "Last Name",
    "student_manager_column_remark_name": "Remark Name",
    "student_manager_column_course_location": "Location",
    "student_manager_column_status": "Status",
    "student_manager_column_init_password": "Init Password",
    "student_manager_column_login_time": "Last Login",

    "student_manager_column_actions": "Actions",
    "student_manager_status_active": "Active",
    "student_manager_status_disabled": "Disabled",
    "student_manager_action_edit": "Edit",
    "student_manager_action_reset_password": "Reset Password",
    "student_manager_action_disable": "Disable",
    "student_manager_action_enable": "Enable",
    "student_manager_action_delete": "Delete",
    "student_manager_action_permanent_delete": "Delete Permanently",
    "student_manager_view_active": "Active Students",
    "student_manager_view_deleted": "Deleted",
    "student_manager_status_deleted": "Deleted",
    "student_manager_column_deleted_at": "Deleted At",
    "student_manager_confirm_delete_title": "Are you sure you want to delete student {{name}}?",
    "student_manager_confirm_delete_content": "The student will be moved to the deleted list.",
    "student_manager_confirm_permanent_delete_title": "Permanently delete student {{name}}?",
    "student_manager_confirm_permanent_delete_content": "This will permanently remove the student record and cannot be undone.",
    "student_manager_msg_permanent_delete_success": "Student permanently deleted",
    "student_manager_msg_permanent_delete_error": "Failed to permanently delete student",
    "student_manager_confirm_disable_title": "Are you sure you want to {{action}} student {{name}}?",
    "student_manager_confirm_disable_content": "This action will change the student's status.",
    "student_manager_modal_create_title": "Create Student",
    "student_manager_modal_edit_title": "Edit Student: {{name}}",
    "student_manager_modal_reset_password_title": "Reset Password: {{name}}",
    "student_manager_form_label_name": "Name",
    "student_manager_form_label_email": "Email",
    "student_manager_form_label_first_name": "First Name",
    "student_manager_form_label_last_name": "Last Name",
    "student_manager_form_label_remark_name": "Remark Name",
    "student_manager_form_label_course_location": "Location",
    "student_manager_form_label_remark": "Remark",
    "student_manager_form_label_init_password": "Initial Password",
    "student_manager_form_label_new_password": "New Password",
    "student_manager_form_label_optional": "(Optional)",
    "student_manager_create_form_hint": "Name and location are required. All other fields are optional and can be left empty.",
    "student_manager_form_optional_empty": "Not filled in — optional",
    "student_manager_form_optional_filled": "Filled in",
    "student_manager_form_placeholder_name": "Enter name",
    "student_manager_form_placeholder_email": "Enter email",
    "student_manager_form_placeholder_first_name": "Enter first name",
    "student_manager_form_placeholder_last_name": "Enter last name",
    "student_manager_form_placeholder_remark_name": "Enter remark name",
    "student_manager_form_placeholder_course_location": "Select location",
    "student_manager_form_placeholder_remark": "Enter remark",
    "student_manager_form_placeholder_init_password": "Leave empty to use global default password",
    "student_manager_form_placeholder_new_password": "Leave empty to use global default password",
    "student_manager_form_hint_password": "Leave empty to use global default password. Resets init password if student has not changed it yet, otherwise resets login password",
    "student_manager_default_init_password_button": "Global Init Password",
    "student_manager_modal_default_init_password_title": "Set Global Initial Password",
    "student_manager_default_init_password_desc": "When set, this password is used automatically when creating students without specifying an initial password. Any valid string is allowed with no length limit.",
    "student_manager_default_init_password_reminder": "Global initial password is configured. It will be used if left empty: {{password}}",
    "student_manager_msg_default_init_password_save_success": "Global initial password saved successfully",
    "student_manager_msg_default_init_password_save_error": "Failed to save global initial password",
    "student_manager_table_total": "Total {{total}}",
};

export const classManager = {
    "class_manager_msg_fetch_error": "Failed to fetch class list",
    "class_manager_msg_create_success": "Class created successfully",
    "class_manager_msg_create_error": "Failed to create class",
    "class_manager_msg_update_status_success": "Class status updated successfully",
    "class_manager_msg_update_status_error": "Failed to update class status",
    "class_manager_msg_delete_success": "Class deleted successfully",
    "class_manager_msg_delete_error": "Failed to delete class",
    "class_manager_msg_copy_success": "Class copied successfully",
    "class_manager_msg_copy_error": "Failed to copy class",
    "class_manager_msg_date_required": "Please select start and end dates",
    "class_manager_msg_init_can_only_change_to_running": "Initialized status can only change to running",
    "class_manager_msg_cannot_change_to_init": "Cannot change back to initialized status",
    "class_manager_status_hint_init_only_running": "Initialized status can only change to running",
    "class_manager_search_placeholder": "Search class name",
    "class_manager_filter_status_placeholder": "Select status",
    "class_manager_search_button": "Search",
    "class_manager_create_button": "Create Class",
    "class_manager_loading": "Loading...",
    "class_manager_no_data": "No data",
    "class_manager_status_init": "Initialized",
    "class_manager_status_running": "Running",
    "class_manager_status_end": "Ended",
    "class_manager_status_disabled": "Disabled",
    "class_manager_action_view": "View",
    "class_manager_action_copy": "Copy",
    "class_manager_action_delete": "Delete",
    "class_manager_confirm_delete_title": "Are you sure you want to delete class {{name}}?",
    "class_manager_confirm_delete_content": "This action cannot be undone.",
    "class_manager_confirm_copy_title": "Are you sure you want to copy class {{name}}?",
    "class_manager_confirm_copy_content": "A new class copy will be created.",
    "class_manager_confirm_change_status_title": "Are you sure you want to change class status to {{status}}?",
    "class_manager_confirm_change_status_content": "Class {{name}} will be set to {{status}} status. Please proceed with caution.",
    "class_manager_modal_create_title": "Create Class",
    "class_manager_modal_view_title": "Class Details: {{name}}",
    "class_manager_modal_close": "Close",
    "class_manager_form_label_name": "Class Name",
    "class_manager_form_label_desc": "Description",
    "class_manager_form_label_date_range": "Date Range",
    "class_manager_form_hint_date_range": "Leave empty to use default: start of current year to 3 years later",
    "class_manager_form_label_status": "Status",
    "class_manager_form_placeholder_name": "Enter class name",
    "class_manager_form_placeholder_desc": "Enter class description",
    "class_manager_card_start_time": "Start Time",
    "class_manager_card_end_time": "End Time",
    "class_manager_detail_name": "Class Name",
    "class_manager_detail_desc": "Description",
    "class_manager_detail_status": "Status",
    "class_manager_detail_start_time": "Start Time",
    "class_manager_detail_end_time": "End Time",
    "class_manager_detail_created_at": "Created At",
    "class_manager_detail_updated_at": "Updated At",
    "class_manager_table_total": "Total {{total}}",
    "class_manager_table_page": "Page {{page}} / {{total}}",
    "class_manager_table_prev": "Previous",
    "class_manager_table_next": "Next",
    "class_manager_view_card": "Card",
    "class_manager_view_list": "List",
    "class_manager_action_edit": "Edit",
    "class_manager_action_add_person": "Add Person",
    "class_manager_msg_update_success": "Class updated successfully",
    "class_manager_msg_update_error": "Failed to update class",
    "class_manager_msg_fetch_users_error": "Failed to fetch user list",
    "class_manager_msg_select_user": "Please select a user",
    "class_manager_msg_add_person_success": "Person added successfully",
    "class_manager_msg_add_person_error": "Failed to add person",
    "class_manager_msg_remove_person_success": "Person removed successfully",
    "class_manager_msg_remove_person_error": "Failed to remove person",
    "class_manager_msg_fetch_detail_error": "Failed to fetch class detail",
    "class_manager_modal_edit_title": "Edit Class: {{name}}",
    "class_manager_modal_add_person_title": "Add Person to Class: {{name}}",
    "class_manager_modal_add_teachers_title": "Add Teachers to Class: {{name}}",
    "class_manager_form_label_person_type": "Person Type",
    "class_manager_person_type_teacher": "Teacher",
    "class_manager_person_type_student": "Student",
    "class_manager_form_label_select_teacher": "Select Teacher",
    "class_manager_form_label_select_student": "Select Student",
    "class_manager_form_placeholder_select_teacher": "Select a teacher",
    "class_manager_form_placeholder_select_student": "Select a student",
    "class_manager_transfer_title_available_teachers": "Available Teachers",
    "class_manager_transfer_title_available_students": "Available Students",
    "class_manager_transfer_title_class_teachers": "Class Teachers",
    "class_manager_transfer_title_class_students": "Class Students",
    "class_manager_action_save": "Save",
    "class_manager_action_cancel": "Cancel",
    "class_manager_msg_save_persons_success": "Persons saved successfully",
    "class_manager_msg_save_persons_error": "Failed to save persons",
    "class_manager_msg_add_teacher_success": "Added {{count}} teacher(s)",
    "class_manager_msg_add_student_success": "Added {{count}} student(s)",
    "class_manager_msg_remove_teacher_success": "Removed {{count}} teacher(s)",
    "class_manager_msg_remove_teacher_partial_error": "Failed to remove {{count}} teacher(s)",
    "class_manager_msg_remove_student_success": "Removed {{count}} student(s)",
    "class_manager_confirm_remove_person_title": "Are you sure you want to remove this person?",
    "class_manager_confirm_remove_person_content": "{{name}} will be removed from the class",
    "class_manager_action_remove": "Remove",
    "class_manager_detail_basic_info": "Basic Information",
    "class_manager_detail_teachers": "Teachers",
    "class_manager_detail_students": "Students",
    "class_manager_no_teachers": "No teachers",
    "class_manager_no_students": "No students",
    "class_manager_column_id": "ID",
    "class_manager_column_name": "Bank Name",
    "class_manager_column_desc": "Description",
    "class_manager_column_status": "Status",
    "class_manager_column_start_time": "Start Time",
    "class_manager_column_end_time": "End Time",
    "class_manager_column_time_range": "Time Range",
    "class_manager_column_actions": "Actions",
    "class_manager_action_manage_add_stu": "Add Student",
    "class_manager_action_add_teacher": "Add Teacher",
    "class_manager_form_label_location": "Location",
    "class_manager_form_placeholder_location": "Please select location",
    "class_manager_form_label_leader_teacher": "Leader Teacher",
    "class_manager_form_placeholder_leader_teacher": "Please select leader teacher",
    "class_manager_form_hint_leader_teacher": "Teacher must be added to class first before setting as leader",
    "class_manager_form_hint_no_teachers": "No teachers in class, please add teachers first",
    "class_manager_detail_location": "Location",
    "class_manager_detail_leader_teacher": "Leader Teacher",
    "class_manager_action_manage_teachers_students": "Manage Teachers/Students",
    "class_manager_modal_manage_persons_title": "Manage Teachers and Students: {{name}}",
    "class_manager_form_label_add_teacher": "Add Teacher",
    "class_manager_form_label_add_student": "Add Student",
    "class_manager_column_subjects": "Subjects",
    "class_manager_form_placeholder_subjects": "Please select subjects",
    "class_manager_action_edit_subjects": "Edit Subjects",
    "class_manager_action_add_subjects": "Add Subjects",
    "class_manager_msg_update_subjects_success": "Subjects updated successfully",
    "class_manager_msg_update_subjects_error": "Failed to update subjects",
    "class_manager_action_add_student": "Add Student",
    "class_manager_action_manage_teacher": "Manage Teachers",
    "class_manager_action_set_homework_bank": "Set Homework Bank",
    "class_manager_action_update_status": "Update Status",
    "class_manager_action_more": "More",
    "class_manager_modal_manage_students_title": "Manage Students: {{name}}",
    "class_manager_modal_manage_teachers_title": "Manage Teachers: {{name}}",
    "class_manager_modal_set_homework_bank_title": "Set Homework Bank: {{name}}",
    "class_manager_modal_update_status_title": "Update Status: {{name}}",
    "class_manager_column_subject": "Subject",
    "class_manager_column_teacher": "Create By",
    "class_manager_column_description": "Description",
    "class_manager_column_is_leader": "Leader",
    "class_manager_leader_yes": "Leader",
    "class_manager_action_set_leader": "Set as Leader",
    "class_manager_action_clear_leader": "Clear Leader",
    "class_manager_confirm_clear_leader": "Are you sure you want to clear this teacher's leader role?",
    "class_manager_msg_set_leader_success": "Leader set successfully",
    "class_manager_msg_set_leader_error": "Failed to set leader",
    "class_manager_msg_clear_leader_success": "Leader cleared successfully",
    "class_manager_msg_clear_leader_error": "Failed to clear leader",
    "class_manager_confirm_remove_teacher": "Are you sure you want to remove this teacher?",
    "class_manager_action_confirm": "Confirm",
    "class_manager_form_label_add_homework_bank": "Add Homework Bank",
    "class_manager_form_placeholder_select_homework_bank": "Please select homework bank",
    "class_manager_form_placeholder_filter_subject": "Filter by subject",
    "class_manager_msg_fetch_homework_bank_error": "Failed to fetch homework bank list",
    "class_manager_msg_add_homework_bank_error": "Failed to add homework bank",
    "class_manager_msg_remove_homework_bank_success": "Homework bank removed successfully",
    "class_manager_msg_remove_homework_bank_error": "Failed to remove homework bank",
    "class_manager_confirm_remove_homework_bank": "Are you sure you want to remove this homework bank?",
    "class_manager_detail_homework_banks": "Homework Banks",
    "class_manager_no_homework_banks": "No homework banks",
    "class_manager_form_label_current_status": "Current Status",
    "class_manager_form_label_new_status": "New Status",
    "class_manager_msg_status_no_change": "Status has not changed",
    "class_manager_action_add": "Add",
    "class_manager_confirm_add_homework_banks": "Are you sure you want to add {{count}} homework bank(s)?",
    "class_manager_confirm_add_teachers": "Are you sure you want to add {{count}} teacher(s)?",
    "class_manager_msg_add_homework_bank_success": "Added {{count}} homework bank(s)",
    "class_manager_msg_add_homework_bank_partial_error": "Some homework banks failed to add ({{count}})",
    "class_manager_msg_add_teacher_partial_error": "Some teachers failed to add ({{count}})",
    "class_manager_cannot_remove_leader": "Leader cannot be removed",
    "class_manager_msg_delete_only_disabled_or_end": "Only ended or disabled classes can be deleted",
    "class_manager_selected_banks": "Selected",
    "class_manager_empty_selected_banks": "Please select homework banks from the left",
    "class_manager_title": "Class Management",
    "class_manager_action_clear_selection": "Clear Selection",
    "class_manager_search_placeholder_homework_bank": "Search homework bank name",
    "class_manager_action_assign_homework": "Assign Homework",
    "class_manager_detail_homeworks": "Homework",
    "class_manager_modal_assign_homework_title": "Assign Homework: {{name}}",
    "class_manager_admin_bank_type_auth": "Authorized Banks",
    "class_manager_admin_bank_type_global": "Global Banks",
    "class_manager_admin_batch_assign": "Batch Assign",
    "class_manager_admin_batch_assign_hint": "Select up to 20 templates",
    "class_manager_admin_assign_success": "Assigned successfully",
    "class_manager_admin_assign_error": "Assign failed",
    "class_manager_admin_batch_assign_success": "Successfully assigned {{count}} homework(s)",
    "class_manager_admin_batch_assign_partial": "{{success}} succeeded, {{fail}} failed",
    "class_manager_admin_pending_list": "Pending List",
    "class_manager_admin_confirm_assign": "Confirm Assign",
    "class_manager_admin_homework_name": "Homework Name",
    "class_manager_admin_remove_from_list": "Remove",
    "class_manager_admin_pending_empty": "Please select templates above to add to the pending list",
    "class_manager_admin_add_to_list": "Add to Pending List",
};
